import { render, staticRenderFns } from "./AssetDetailEditor.vue?vue&type=template&id=cca6ddc2&scoped=true"
import script from "./AssetDetailEditor.vue?vue&type=script&lang=js"
export * from "./AssetDetailEditor.vue?vue&type=script&lang=js"
import style0 from "./AssetDetailEditor.vue?vue&type=style&index=0&id=cca6ddc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca6ddc2",
  null
  
)

export default component.exports